// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myListsEditListFormStyles } from "@conklin/Overrides/Widgets/MyLists/MyListsEditListForm";
import { mergeWithCss, modalButtonsActionStyles } from "@conklin/XDL/Utilities";
import { GridItemProps } from "@insite/mobius/GridItem";
import { css } from "styled-components";

const gridItemStyles = {
    width: 12,
    css: css`
        padding-bottom: 16px;
    `,
} as GridItemProps;

myListsEditListFormStyles.container = {
    gap: 0,
};

myListsEditListFormStyles.buttonsGridItem = {
    ...modalButtonsActionStyles.buttonsGridItem,
};

myListsEditListFormStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};

myListsEditListFormStyles.createButton = {
    ...modalButtonsActionStyles.submitButton,
};

myListsEditListFormStyles.nameGridItem = myListsEditListFormStyles.descriptionGridItem = gridItemStyles;

myListsEditListFormStyles.descriptionTextArea = {
    css: css`
        resize: vertical;
    `,
};
